import { UTM_PARAMS } from '../context/AnalyticsContext/constants';

/**
 * Extracts UTM parameters from a URL
 *
 * @param url - The URL to extract UTM parameters from
 * @returns An object containing all UTM parameters found in the URL
 */
export const extractUtmParams = (url: string): Record<string, string> => {
  // Create URLSearchParams from the search string
  const searchParams = new URLSearchParams(url);

  const utmParams: Record<string, string> = {};

  // Get all UTM parameter keys from the enum
  const utmParamKeys = Object.values(UTM_PARAMS);

  // Process each UTM parameter
  utmParamKeys.forEach((paramKey) => {
    const value = searchParams.get(paramKey);
    if (value) {
      utmParams[paramKey] = value;
    }
  });

  return utmParams;
};

/**
 * Extracts UTM parameters from the current URL
 *
 * @returns An object containing all UTM parameters found in the current URL
 */
export const extractCurrentUrlUtmParams = (): Record<string, string> => {
  if (typeof window === 'undefined') {
    return {};
  }

  return extractUtmParams(window.location.search);
};
